/**
 * 
 * key
 * 
 */


const key = 'cGxQcm9kdWN0U3RhdHVzQWdpbmdSZXBvcnQ='

export default key 